import React from 'react';
import classlist from 'utils/classlist';
import './index.scss';

interface EntryContentProps {
    content: string;
    className?: string;
}

const EntryContent: React.FC<EntryContentProps> = ({ content, className }) => {
    return <div className={classlist('comp-entry-content', className)} dangerouslySetInnerHTML={{ __html: content }} />;
};

export default EntryContent;
